var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dashboard_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.5 13.5V4.5H31.5V13.5H19.5ZM4.5 19.5V4.5H16.5V19.5H4.5ZM19.5 31.5V16.5H31.5V31.5H19.5ZM4.5 31.5V22.5H16.5V31.5H4.5ZM7.5 16.5H13.5V7.5H7.5V16.5ZM22.5 28.5H28.5V19.5H22.5V28.5ZM22.5 10.5H28.5V7.5H22.5V10.5ZM7.5 28.5H13.5V25.5H7.5V28.5Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.abaaa8bbfd1bfbcf30422ab25c9ebbc8.svg";
export { ForwardRef as ReactComponent };